import { ApiService } from './api.service'

const BaseUrl = '/point-exchange-services'

export function getPointExchangeList (params = {}) {
  return ApiService.get(`${BaseUrl}`, params).then(resp => resp)
}
